/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_ConditionInputs */

const cs_enum_condition = /** @type {(inputs: Enum_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav`)
};

const en_enum_condition = /** @type {(inputs: Enum_ConditionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condition`)
};

/**
* | output |
* | --- |
* | "Condition" |
*
* @param {Enum_ConditionInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_condition = /** @type {((inputs?: Enum_ConditionInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_ConditionInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_condition(inputs)
	return cs_enum_condition(inputs)
});